module.exports = __webpack_public_path__ + "static/media/propic-1.28db2e49.png";